import { SVGProps, memo } from 'react';

const WeblinkIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width={props.width || "19"} height={props.height || "15"} viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_5446_57512" fill="white">
    <rect y="0.279785" width="19" height="14.44" rx="0.76"/>
    </mask>
    <rect y="0.279785" width="19" height="14.44" rx="0.76" stroke={props.stroke || "#212121"} stroke-width="2.432" mask="url(#path-1-inside-1_5446_57512)"/>
    <path d="M0.759766 0.888184H18.2402C18.324 0.88831 18.3915 0.95579 18.3916 1.03955V5.75146H0.608398V1.03955C0.608525 0.95579 0.676004 0.88831 0.759766 0.888184Z" stroke={props.stroke || "#212121"} stroke-width="1.216"/>
    <path d="M10.2598 3.31982H16.3398" stroke={props.stroke || "#212121"} stroke-width="1.216"/>
    <path d="M3.04004 3.31982H4.56004" stroke={props.stroke || "#212121"} stroke-width="1.216"/>
    </svg>
  );
};

export default memo(WeblinkIcon);
